import { redirect } from 'react-router';

import type { ForumPost } from '~/api/forum/types';
import type { Params } from '~/providers/RouterProvider/router.types';

import { HttpNotFoundError } from '~/api/errors';
import { forumPostQueryOptions } from '~/api/forum/useForumPost';
import { queryClient } from '~/providers/QueryClientProvider/queryClient';
import { routes } from '~/providers/RouterProvider/router.routes';

export const loader = async ({ params }: { params: Params<typeof routes.forumPost> }): Promise<ForumPost> => {
  const postId = Number(params.postId);

  try {
    return await queryClient.ensureQueryData(forumPostQueryOptions(postId));
  } catch (error) {
    if (error instanceof HttpNotFoundError) {
      throw redirect(routes.forumTimeline);
    }

    throw error;
  }
};
